var UrlFormatter = /** @class */ (function () {
    function UrlFormatter() {
        this.wordSeparator = "-";
        this.cleaner = new RegExp(/(\.+?\)|\[.+?\])/);
        this.wordBoundaires = [" ", "_", ",", ".", ":", "$", "&"];
        this.skipSymbols = [" ", "\"", "'", "@", "%", "*", "\t", "\n", "\r", "/", "$", "&", "+", ".", ","];
    }
    UrlFormatter.prototype.cleanUrl = function (url) {
        var _this = this;
        var skipSymbols = this.skipSymbols;
        var formattedUrl = url.toLocaleLowerCase().trim().replace(this.cleaner, "");
        var parameters = {
            word: "",
            currentChar: "",
            res: [],
            wordSeparatorCheck: false,
            startWord: false
        };
        for (var i = 0; i < formattedUrl.length; i++) {
            parameters.currentChar = formattedUrl[i];
            var wordSeparatorCheck = this.checkCondition(parameters.res, true);
            if (wordSeparatorCheck && this.sameAsSeparator(parameters.currentChar)) {
                continue;
            }
            this.wordBoundaires.forEach(function (word) {
                parameters.word = word;
                _this.processWordBoundaries(parameters);
            });
            if (skipSymbols.indexOf(parameters.currentChar) >= 0) {
                continue;
            }
            parameters.res.push(parameters.currentChar);
            parameters.startWord = false;
        }
        return parameters.res.join("");
    };
    UrlFormatter.prototype.checkCondition = function (array, equals) {
        if (array.length > 0 && equals) {
            return this.sameAsSeparator(array[array.length - 1]);
        }
        return false;
    };
    UrlFormatter.prototype.sameAsSeparator = function (word) {
        return word === this.wordSeparator;
    };
    UrlFormatter.prototype.processWordBoundaries = function (parameters) {
        if (!parameters.startWord && parameters.currentChar === parameters.word) {
            parameters.wordSeparatorCheck = this.checkCondition(parameters.res, false);
            if (!parameters.wordSeparatorCheck) {
                parameters.res.push(this.wordSeparator);
            }
            parameters.startWord = true;
        }
    };
    return UrlFormatter;
}());
export { UrlFormatter };
var instance = new UrlFormatter();
export var cleanUrl = instance.cleanUrl.bind(instance);
//# sourceMappingURL=UrlFormatter.js.map